<template>
  <div class="text-center fifth">
    <el-row  class="hidden-sm-and-down">
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30,40]"
      :page-size="10"
	  :current-page.sync="index.PageIndex"
      layout="total, sizes, prev, pager, next, jumper"
      :total='count'>
    </el-pagination>
   </el-row>

<el-row  class="hidden-md-and-up">
  <el-pagination
    @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    layout="prev, pager, next"
    :total='count'>
   </el-pagination>
</el-row>
  </div>
</template>

<script>
    export default {
        name: "CommonPage",
        data(){
          return{
            
          }
        },
        props: ["count","index"],
        mounted(){
        },
        methods:{
          handleSizeChange(val){//
            this.$emit('pageSize',val)
          },
          handleCurrentChange(val){
            this.$emit('pageindex',val)
            window.scrollTo(0,0);
          }
        }
    }
</script>

<style scoped>

</style>
